import styled from "styled-components"
import successImg from "@irati/ui/images/success.svg"

const FailedUser = styled.div`
  padding: 25px 30px;
  position: relative;
  display: flex;
  align-items: center;
  background-image: linear-gradient(#979797 33%, rgba(255, 255, 255, 0) 0%),
    linear-gradient(to right, #979797 33%, rgba(255, 255, 255, 0) 0%),
    linear-gradient(#979797 33%, rgba(255, 255, 255, 0) 0%);
  background-position: right, top, left;
  background-size: 1px 20px, 20px 1px, 1px 20px;
  background-repeat: repeat-y, repeat-x, repeat-y;
  
  ${(props) => props.success && `
    &:after{
      content: '';
      position: absolute;
      top: 50%;
      right: 0;
      width: 43px;
      height: 43px;
      background-image: url(${successImg});
      background-size: cover;
      transform: translate(0, -50%);
    }
  `}
  
  &:last-child {
    margin-bottom: 50px;
    background-image: linear-gradient(to right, #979797 33%, rgba(255, 255, 255, 0) 0%),
      linear-gradient(#979797 33%, rgba(255, 255, 255, 0) 0%),
      linear-gradient(to right, #979797 33%, rgba(255, 255, 255, 0) 0%),
      linear-gradient(#979797 33%, rgba(255, 255, 255, 0) 0%);
    background-position: bottom, right, top, left;
    background-size: 20px 1px, 1px 20px, 20px 1px, 1px 20px;
    background-repeat: repeat-x, repeat-y, repeat-x, repeat-y;
  }
`

export default FailedUser
